export const initialState = {
  students: [{ id: "01", firstName: "", lastName: "" }],
  isInviting: false,
  createdChilds: [],
  indexRef: 0,
};
